// extracted by mini-css-extract-plugin
module.exports = {"boardingButton":"containers-Dashboard-FhlmcResolve-FHLMCPreapproved__boardingButton--19EU-","table":"containers-Dashboard-FhlmcResolve-FHLMCPreapproved__table--3G1wJ"};